import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import AdminTerms from '@/components/terms/AdminTerms';
import { AdminTermsRes } from '@/components/terms/AdminTerms/types';
import { getAdminAmexTerms } from '@/utils/admin';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const TermsAmexGlobalPage = ({ terms }: AdminTermsRes) => (
	<Layout pageName="terms-amex-global" title={`Calm - ${terms.name}`}>
		<AdminTerms terms={terms} />
	</Layout>
);

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	const terms = await getAdminAmexTerms(initialState?.device ?? null, '/terms-amex-global');
	if (terms === null) {
		// eslint-disable-next-line require-atomic-updates
		context.res.statusCode = 500;
		// eslint-disable-next-line require-atomic-updates
		context.res.statusMessage = 'Amex Global Terms are missing.';
		context.res.end();
	}

	return {
		props: {
			terms,
		},
	};
};

export default TermsAmexGlobalPage;
